function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EuropeanUnionFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M24 3H0V21H24V3Z",
    fill: "#2E42A4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.304 5L12.6925 6.1459H13.9497L12.9326 6.85408L13.3211 7.99998L12.304 7.29174L11.2868 7.99998L11.6754 6.85408L10.6582 6.1459H11.9154L12.304 5Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.13942 7.04937L8.25973 7.59633L9.14869 6.74445L8.95196 7.93441L10.0722 8.48142L8.83046 8.66991L8.63378 9.85996L8.06299 8.78638L6.82129 8.97492L7.71026 8.123L7.13942 7.04937Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5 11.9995L6.19571 11.6272V10.4224L6.93464 11.3971L8.13041 11.0248L7.39134 11.9995L8.13041 12.9743L6.93464 12.6019L6.19571 13.5767V12.3719L5 11.9995Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.13942 16.9483L7.71022 15.8746L6.82129 15.0228L8.06304 15.2113L8.63373 14.1378L8.83046 15.3277L10.0722 15.5162L8.95205 16.0632L9.14869 17.2532L8.25973 16.4013L7.13942 16.9483Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.304 19L11.9154 17.8542H10.6582L11.6754 17.146L11.2868 16.0001L12.304 16.7083L13.3211 16.0001L12.9326 17.146L13.9497 17.8542H12.6925L12.304 19Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.469 16.9483L16.3488 16.4013L15.4598 17.2533L15.6566 16.0632L14.5364 15.5162L15.7781 15.3277L15.9747 14.1378L16.5455 15.2113L17.7872 15.0228L16.8982 15.8747L17.469 16.9483Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19.6085 11.9995L18.4128 12.3719V13.5767L17.6739 12.6019L16.4783 12.9743L17.2172 11.9995L16.4783 11.0248L17.6739 11.3971L18.4128 10.4224V11.6272L19.6085 11.9995Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.469 7.04933L16.8982 8.12295L17.7873 8.97488L16.5455 8.7863L15.9747 9.85987L15.7781 8.66986L14.5364 8.48133L15.6566 7.93437L15.4598 6.74445L16.3488 7.59633L17.469 7.04933Z",
    fill: "#FFDA44"
  })]
}));
//# sourceMappingURL=EuropeanUnion.js.map